import { DateTime } from 'luxon';
import { FC } from 'react';

import AttributeItem from 'dashboard/components/AttributeItem';
import FeatureFlagged from 'dashboard/components/FeatureFlagged/FeatureFlagged';
import { InfoGrid } from 'dashboard/layouts/ShowViewLayoutV2';
import { Account } from 'dashboard/models/account';
import Card from 'design-system/components/Card';
import { DATE_AND_TIME_TZ_FORMAT } from 'lib/constants/luxonFormats';
import { Iso8601DateString } from 'lib/types';

interface AccountInfoProps {
  account: Account;
  accountTypeName: string;
}

// TODO: remove this when account type layout editor is fully released
const AccountInfo: FC<AccountInfoProps> = ({ account, accountTypeName }) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Info</Card.Title>
        <InfoGrid>
          <FeatureFlagged featureFlag='dashboard:accounts-show-account-type'>
            {/*todo: gary - once the account type configuration tool is built, link to there*/}
            <AttributeItem
              title='Account Type'
              value={accountTypeName}
              isRedacted={false}
              wordBreak='break-all'
              placeholder=''
              dataTest='account-info__account-type'
            />
          </FeatureFlagged>
          <AttributeItem
            title='Account ID'
            value={account.id}
            isRedacted={false}
            wordBreak='break-all'
            placeholder=''
            dataTest='account-info__account-id'
          />
          <AttributeItem
            title='Reference ID'
            value={account.attributes['reference-id'] || null}
            isRedacted={false}
            placeholder='No reference ID'
            wordBreak='break-all'
            dataTest='account-info__reference-id'
          />
          <AttributeItem
            title='Created at'
            value={DateTime.fromISO(account.attributes['created-at'] as Iso8601DateString).toFormat(
              DATE_AND_TIME_TZ_FORMAT,
            )}
            isRedacted={false}
            placeholder=''
            wordBreak='break-all'
            dataTest='account-info__created-at'
          />
          <AttributeItem
            title='Last updated at'
            value={DateTime.fromISO(account.attributes['updated-at'] as Iso8601DateString).toFormat(
              DATE_AND_TIME_TZ_FORMAT,
            )}
            isRedacted={false}
            placeholder=''
            wordBreak='break-all'
            dataTest='account-info__last-updated'
          />
        </InfoGrid>
      </Card.Body>
    </Card>
  );
};

export default AccountInfo;
